var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBillingColoured(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Paper_fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 21V7C4 5.11438 4 4.17157 4.58579 3.58579C5.17157 3 6.11438 3 8 3H21.2718C21.9266 3 22.5143 3 23.0442 3.00741C20.6802 3.14233 18.8047 5.10214 18.8047 7.5V11H18.8044L18.6825 20.9671L15.1033 20L11.4022 21L7.7011 20L4 21ZM6.70099 7C6.70099 6.44772 7.14871 6 7.70099 6H15.1032C15.6555 6 16.1032 6.44772 16.1032 7C16.1032 7.55228 15.6555 8 15.1032 8H7.70099C7.14871 8 6.70099 7.55228 6.70099 7ZM6.70099 11C6.70099 10.4477 7.14871 10 7.70099 10H10.1684C10.7207 10 11.1684 10.4477 11.1684 11C11.1684 11.5523 10.7207 12 10.1684 12H7.70099C7.14871 12 6.70099 11.5523 6.70099 11ZM6.70099 15C6.70099 14.4477 7.14871 14 7.70099 14H12.6358C13.1881 14 13.6358 14.4477 13.6358 15C13.6358 15.5523 13.1881 16 12.6358 16H7.70099C7.14871 16 6.70099 15.5523 6.70099 15Z",
    fill: "#008AED"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillingColoured);
export default __webpack_public_path__ + "static/media/Billing_Coloured.0a7fb7c71ee734fa079e3bb033662a88.svg";
export { ForwardRef as ReactComponent };